import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { GooglePlay, Apple } from "react-bootstrap-icons";
import JoinGroupImage from "../images/join_group.svg";
import PostRequestImage from "../images/post_request.svg";
import TravelTogetherImage from "../images/nails.jpg";
import { Helmet } from "react-helmet";

function Landing() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Boque - Beauty appointments on the go</title>
        <link rel="canonical" href="https://boque.me" />
        <meta
          name="description"
          content="Book beauty appointments instantly."
        />
      </Helmet>
      <div
        className="header"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col md={8}>
              <h1>Get your nails done on the go...</h1>
              <p className="mt-3 fs-4">
                Book manicure and pedicure appointments on the go with our
                revolutionary app. Its fast, its instant and our manicurists
                will get to you in record time and provide a great service.
              </p>
            </Col>
            <Col md={4}>
              <h1>It's free</h1>
              <p className="mt-3 fs-4">Download the app to get started</p>
              <a
                className="btn btn-primary btn-lg me-2"
                size="lg"
                //href="https://apps.apple.com/us/app/cabbily/id1624355642"
                target="_blank"
                rel="noreferrer"
              >
                <div className="d-flex flex-row align-items-center justify-content-center">
                  <Apple size={22} color="#ffffff" className="me-2" />
                  iOS App
                </div>
              </a>
              <a
                className="btn btn-primary btn-lg me-2"
                size="lg"
                //href="https://play.google.com/store/apps/details?id=com.cabbily.cabbily"
                target="_blank"
                rel="noreferrer"
              >
                <div className="d-flex flex-row align-items-center">
                  <GooglePlay size={22} color="#ffffff" className="me-2" />
                  Android App
                </div>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="mt-3">
          <h2 className="text-center">How it works</h2>
          <Col md={4} className="mt-2">
            <Card>
              <Card.Body>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={JoinGroupImage}
                    alt="Download the App"
                    width="90%"
                    height="200px"
                  />
                  <h4 className="mt-3">Download the App</h4>
                  <p className="text-center">
                    Join us by downloading the app on Android or iOS.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mt-2">
            <Card>
              <Card.Body>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={PostRequestImage}
                    alt="Post Request"
                    width="90%"
                    height="200px"
                  />
                  <h4 className="mt-3">Schedule Appointment</h4>
                  <p className="text-center">
                    Pick a nail style, a time and a place. We got you covered.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mt-2">
            <Card>
              <Card.Body>
                <div className="d-flex flex-column  justify-content-center align-items-center">
                  <img
                    src={TravelTogetherImage}
                    alt="Travel Together"
                    width="90%"
                    height="200px"
                  />
                  <h4 className="mt-3">Get Service</h4>
                  <p className="text-center">
                    A manicurist will be sent to your location to work on you.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Landing;
